<ion-header>
  <ion-toolbar no-border-top>
    <span
      class="tab-nav-link"
      [routerLink]="'/super-admin/tenants'"
      routerDirection="root"
      routerLinkActive="tab-nav-active"
    >
      Tenants
    </span>
    <span
      class="tab-nav-link"
      [routerLink]="'/super-admin/help-center-demo'"
      routerDirection="root"
      routerLinkActive="tab-nav-active"
    >
      Customer Portal Demo
    </span>
    <span
      class="tab-nav-link"
      [routerLink]="'/super-admin/deployments'"
      routerDirection="root"
      routerLinkActive="tab-nav-active"
    >
      Deployments
    </span>
    <span
      class="tab-nav-link"
      [routerLink]="'/super-admin/taxonomy'"
      routerDirection="root"
      routerLinkActive="tab-nav-active"
    >
      Taxonomy
    </span>
    <span
      class="tab-nav-link"
      [routerLink]="'/super-admin/knowledge-gaps'"
      routerDirection="root"
      routerLinkActive="tab-nav-active"
    >
      Knowledge Gaps
    </span>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-router-outlet id="super-admin-router"></ion-router-outlet>
</ion-content>
